<template>
  <div id="mMember">
    <Nav type="transparent" />
    <span class="pageTitle">会员服务</span>
    <div style="height: 1px;"></div>
    <div class="blockTit">会员特权及说明</div>
    <template v-for="(item, index) in memberData.cards">
      <div class="card clearfix">
        <img :src="require(`@/${item.icon}`)" alt />
        <div class="cardName">{{ item.name }} {{ item.price }}</div>
        <div class="cardInfo">
          <p>
            <strong>{{ item.basicRightsTitle || `基础权益` }}</strong>
          </p>
          <template v-for="right in item.basicRights">
            <p>
              <span>·</span>
              <span>{{ right }}</span>
            </p>
          </template>
        </div>
        <template v-if="item.valueRights">
          <div class="cardInfo">
            <p>
              <strong>{{ item.valueRightsTitle || `增值权益` }}</strong>
            </p>
            <template v-for="right in item.valueRights">
              <p>
                <span>·</span>
                <span>{{ right }}</span>
              </p>
            </template>
          </div>
        </template>
      </div>
    </template>
    <div class="cardNote">
      <template v-for="(note, index) in memberData.notes">
        <p><span v-if="index === 0">*</span>{{index + 1}} {{ note }} <mu-icon v-if="index === memberData.notes.length - 1" class="mIcon" size="26" value="info_outline" @click="table = true"></mu-icon></p>
      </template>
      
    </div>
    <mu-dialog title class="mTable" width="750" :open.sync="table">
      <i class="close" @click="table = false"></i>
      <div class="imgBox">
        <!-- <img src="../assets/pageM.png" alt /> -->
        <mu-data-table :height="`1300px`" stripe :columns="columns" :data="list" :fit="false">
          <template slot-scope="scope">
            <td>{{scope.row.name}}</td>
            <td>{{scope.row.time}}</td>
            <td>¥{{scope.row.price}}</td>
            <td>¥{{scope.row.l1Price}}</td>
            <td>¥{{scope.row.l2Price}}</td>
            <td>¥{{scope.row.l3Price}}</td>
          </template>
        </mu-data-table>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import memberData from "@/utils/member.js";
export default {
  name: "Member",
  data() {
    return {
      // table: false,
      memberData: memberData,
      active: -1,
      table: false,
      list: memberData.products,
      columns: [
        { title: "项目", width: 200, name: "name" },
        { title: "时长", width: 90, name: "time" },
        { title: "门市价", width: 110, name: "price" },
        { title: "VIP卡", width: 110, name: "l1Price" },
        { title: "明星卡", width: 110, name: "l2Price" },
        { title: "钻石卡", width: 110, name: "l3Price" }
      ]
    };
  },
  components: {
    Nav
  },
  computed: {},
  methods: {
    setActive(i) {
      this.active = this.active === i ? -1 : i;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
#mMember {
  padding: 350px 32px 140px;
  background: url(../assets/member-banner.jpg) top/100% no-repeat;
}
.blockTit {
  margin: 104px 0 56px;
}
.blockText {
  font-size: 28px;
  line-height: 48px;
  text-align: left;
  > p {
    display: flex;
    > span:last-child {
      flex: 1;
    }
  }
}
.card {
  margin: 32px auto 0;
  padding: 80px 28px;
  width: 686px;
  background: #f8f9f8;
  > img {
    display: block;
    margin: 0 auto;
  }
  .cardName {
    margin: 40px 0 64px;
    font-size: 30px;
    line-height: 32px;
    color: #333;
    text-align: center;
  }
  .cardInfo {
    margin-top: 40px;
    font-size: 28px;
    line-height: 48px;
    color: #555;
    > p {
      display: flex;
      > span:last-child {
        flex: 1;
      }
    }
  }
}
.cardNote {
  margin: 16px 0 0 10px;
  font-size: 20px;
  line-height: 32px;
  color: #b0b0b0;
}
.mIcon {
  position: relative;
  top: 6px;
  color: #d1d1d1;
}
.luckdraw {
  display: flex;
  justify-content: center;
  align-items: center;
  
  img {
    display: block;
    margin: 128px 0 24px;
    width: 686px;
  }
}
</style>
<style lang="scss">
.mTable  {
  .mu-dialog-body {
    padding-top: 80px;
  }
  .mu-table {
    th, td {
      padding: 0 16px;
      font-size: 16px;
      height: 72px;
    }
    th {
      font-size: 20px;
      color: #fff;
      background-color: #9b9b9d;
    }
  }
}
</style>